import axios from "axios";

class ApiService {
  constructor() {
    this.baseUrl = process.env.REACT_APP_API_URL || "http://localhost:1337/";

    this.defaultAxios = axios.create({
      baseURL: this.baseUrl,
    });

    this.defaultAxios.interceptors.response.use(
      (response) => response,
      (error) => {
        return Promise.reject(error.response);
      }
    );
  }

  async get(suffix, token = "") {
    let dataHeaders = {};
    dataHeaders["Content-Type"] = "text/plain";
    if( token !== "" ) {
      dataHeaders["authorization"] = `Bearer ${token}`;
    }

    return await this.defaultAxios.get(suffix, { headers: dataHeaders });
  }

  async put(suffix, params, token = "") {
    let dataHeaders = {};
    dataHeaders["Content-Type"] = "text/plain";
    if( token !== "" ) {
      dataHeaders["authorization"] = `Bearer ${token}`;
    } 

    return await this.defaultAxios.put(suffix, params, { headers: dataHeaders });
  }

  async post(suffix, params, token = "") {
    let dataHeaders = {};
    dataHeaders["Content-Type"] = "text/plain";
    if( token !== "" ) {
      dataHeaders["authorization"] = `Bearer ${token}`;
    } 

    return await this.defaultAxios.post(suffix, params, { headers: dataHeaders });
  }

  async delete(suffix, params) {
    return await this.defaultAxios.delete(suffix, params);
  }

  async patch(suffix, params) {
    return await this.defaultAxios.patch(suffix, params);
  }
}

export default new ApiService();
